<div class="table-panel">
  <project-panel-header
    [panelDef]="panelDef"
    [project]="project"
    (onEditPanel)="onEditPanel($event)"
  ></project-panel-header>
  <div class="table-panel__body">
    <app-related-table-core
      [panelDef]="panelDef"
      [account]="account"
      [project]="project"
      [relatedToType]="relatedToTypeProject"
      [readonly]="readonly"
    ></app-related-table-core>
  </div>
</div>
